import { useTranslation } from 'react-i18next';

const PHONE_NUMBER = '+19862173604';

export default function StickyMobileBar() {
  const { t, i18n } = useTranslation();
  const waLink = i18n.language === 'es'
    ? 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.'
    : 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.';

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-black/95 backdrop-blur-md border-t border-white/10 px-4 py-3 flex gap-3">
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm py-3 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-whatsapp-line text-base"></i>
        </div>
        {t('btn_order_whatsapp')}
      </a>
      <a
        href={`tel:${PHONE_NUMBER}`}
        className="flex-1 flex items-center justify-center gap-2 bg-[#F57F25] hover:bg-[#e06d15] text-black font-bold text-sm py-3 rounded-xl transition-all duration-200 cursor-pointer whitespace-nowrap"
      >
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-phone-line text-base"></i>
        </div>
        {t('btn_call_now')}
      </a>
    </div>
  );
}
